import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { LabelM } from '@sorare/core/src/atoms/typography';
import { Bold } from '@sorare/core/src/atoms/typography/Bold';

type Props = { completedOrClaimed: boolean; description: string };
export const ObjectiveDescription = ({
  completedOrClaimed,
  description,
}: Props) => {
  return (
    <>
      <FontAwesomeIcon
        icon={faCheckCircle}
        color={completedOrClaimed ? 'var(--c-green-600)' : 'var(--c-nd-500)'}
      />
      <LabelM>
        <FormattedMessage
          id="Compose.ObjectiveBar.objectiveDescription"
          defaultMessage="<b>Objective:</b> {description}"
          values={{ b: Bold, description }}
        />
      </LabelM>
    </>
  );
};
